module.exports = __webpack_public_path__ + "img/search_1.42ca5267.png";